/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    ModalHeader: {
        id: 'qnb.spt.SgSptAnnualUpgradeDeclinedModal.ModalHeader',
        defaultMessage: 'We are sorry'
    },
    ModalBody1: {
        id: 'qnb.spt.SgSptAnnualUpgradeDeclinedModal.ModalBody1',
        defaultMessage: 'Unfortunately, due to the medical conditions you\'ve declared we can\'t cover you for the region you\'ve asked for. An annual policy to a different region or booking a single trip could be a better option, why not take a look.'
    },
    Return: {
        id: 'qnb.spt.SgSptAnnualUpgradeDeclinedModal.Return',
        defaultMessage: 'Return to single trip'
    }
});
